module.exports = __webpack_public_path__ + "img/success.4a2e1da5.png";